<template>
  <div>
    <div class="notice-wrapper" v-for="event in eventList" :key="event.id">
      <div class="notice-time">
        <p class="notice-time-date">{{ formatEventsItemDate(event.date, "MM-DD") }}</p>
        <p class="notice-time-year">{{ formatEventsItemDate(event.date, "YYYY") }}</p>
      </div>
      <div class="notice-line">
        <div class="notice-line-tail"></div>
        <div class="notice-line-head" :class="headerAcive(event)"></div>
      </div>
      <div class="notice-content">
        <div class="notice-content-title">
          <span v-if="event.jumpUrl" style="color: #4e88ff" @click="jumpToTitleDetail(event.jumpUrl)">{{ event.title
          }}</span>
          <span v-else>{{ event.title }}</span>
          <template v-if="event.expandList && event.expandList.length > 0">
            <span v-show="event.showExpand" class="notice-content-btn" @click="changeShowExpand(event)">收起列表<van-icon
                name="arrow-up" size="12" /></span>
            <span v-show="!event.showExpand" class="notice-content-btn" @click="changeShowExpand(event)">{{
              showExpandTags(event) }}<van-icon name="arrow-down" size="12" /></span>
          </template>
        </div>
        <template v-if="event.expandList && event.expandList.length > 0">
          <div v-show="event.showExpand" class="notice-content-detail">
            <div class="notice-content-detail-wrapper">
              <div class="expand-wrapper" v-for="item in event.expandList" :key="item.uniquekey">
                <!-- 防止类似投资互动没有标题导致空白 -->
                <template v-if="item.title && item.date">
                  <div class="expand-top">
                    <div class="expand-title">{{ item.title }}</div>
                    <div class="expand-time">{{ item.date }}</div>
                  </div>
                  <div class="expand-content">
                    <span>{{ item.content }}</span>
                    <template v-if="item.detail && item.detail.length">
                      <span v-show="item.showDetail" class="arrow-detail" @click="changeShowDetail(item)"><van-icon
                          name="arrow-up" size="12" /></span>
                      <span v-show="!item.showDetail" class="arrow-detail" @click="changeShowDetail(item)"><van-icon
                          name="arrow-down" size="12" /></span>
                    </template>
                    <div v-show="item.showDetail" class="content-detail-list-box">
                      <div v-for="(detail, dIndex) in item.detail" :key="dIndex">
                        <p>
                          {{ detail.content }}
                          <span v-if="detail.noticeSeq" class="jump-affiche-detail"
                            @click="jumpToAfficheDetail(detail.noticeSeq)">[查看公告]</span>
                        </p>
                      </div>
                    </div>
                    <span v-if="item.noticeSeq" class="jump-affiche-detail"
                      @click="jumpToAfficheDetail(item.noticeSeq)">[查看公告]</span>
                  </div>
                </template>
                <p v-else>{{ item.content }}</p>
              </div>
            </div>
          </div>
        </template>
        <div v-show="!event.showExpand" class="notice-content-content">
          {{ event.content }}
          <template v-if="event.detail && event.detail.length">
            <span v-show="event.showDetail" class="arrow-detail" @click="changeShowDetail(event)"><van-icon
                name="arrow-up" size="12" /></span>
            <span v-show="!event.showDetail" class="arrow-detail" @click="changeShowDetail(event)"><van-icon
                name="arrow-down" size="12" /></span>
          </template>
          <div v-show="event.showDetail" class="content-detail-list-box">
            <div v-for="(detail, dIndex) in event.detail" :key="dIndex">
              <p>
                {{ detail.content }}
                <span v-if="detail.noticeSeq" class="jump-affiche-detail"
                  @click="jumpToAfficheDetail(detail.noticeSeq)">[查看公告]</span>
              </p>
            </div>
          </div>
          <span v-if="event.noticeSeq" class="jump-affiche-detail"
            @click="jumpToAfficheDetail(event.noticeSeq)">[查看公告]</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Icon } from 'vant';
import { jumpActivity } from '../utils/oemUtils';

export default {
  name: 'event-list',
  components: {
    [Icon.name]: Icon,
  },
  props: {
    eventList: {
      type: Array,
      default: () => ({}),
    },
  },
  methods: {
    showExpandTags(event) {
      switch (event.cate) {
      case 'allot': // 分配方案
        return '事件进展';
      case 'interactive': // 投资互动
        return '互动精选';
      case 'stockallot': // 配股完成
        return '事件进展';
      case 'disclose': // 中报公告
        return '事件进展';
      default:
        return '延伸阅读';
      }
    },
    headerAcive(event) {
      const date = new Date().getTime() / this.$num.num_1000;
      const eventTime = dayjs(event.date).unix();
      return eventTime - date >= 0 ? 'active' : '';
    },
    changeShowDetail(item) {
      if (typeof item.showDetail === 'undefined' || item.showDetail === null) {
        this.$set(item, 'showDetail', true);
      } else {
        item.showDetail = !item.showDetail;
      }
    },
    /**
     * @description 公告时间类型
     */
    formatNewsItemDate(val) {
      return !val ? '' : dayjs(val * this.$num.num_1000).format('YYYY-MM-DD');
    },
    /**
     * @description 格式化大事提醒时间
     */
    formatEventsItemDate(val, str) {
      return dayjs(val).format(str);
    },
    /**
     * @description 展开、收起
     */
    changeShowExpand(event) {
      event.showExpand = !event.showExpand;
    },
    /**
     * @description 标题跳转
     */
    jumpToTitleDetail(url) {
      let targetUrl = url;
      if (!url.match(/http:|https:/)) {
        targetUrl = `https:${  url}`;
      }
      jumpActivity('2', targetUrl);
    },
    /**
     * @description 跳转到公告详情
     */
    jumpToAfficheDetail(seq) {
      // const url = `https://b2b-api.10jqka.com.cn/b2bgw/resource/h5/private/SWHY/latest/stockInfo/stockInfo/#/affiche-detail?id=${seq}&hxtheme=${+IsDark()}`;
      // seq && jumpActivity('2', url);

      const { accessKey } = this.$route.query;
      this.$native.openNewWebview(`/afficheDetail?id=${seq}&accessKey=${accessKey}`);
    },
  }
};
</script>

<style lang="less" scoped>
.jump-affiche-detail {
  display: inline-block;
  margin-left: 6px;
  color: #4e88ff;
}

.notice-wrapper {
  display: flex;
  margin: 12px 15px;

  .notice-time {
    width: 35px;
    white-space: nowrap;

    &-date {
      text-align: right;
      line-height: 12px;
    }

    &-year {
      text-align: right;
      color: #afafaf;
      transform: scale(10/12);
    }
  }

  .notice-line {
    position: relative;
    width: 10px;
    box-sizing: border-box;
    margin-right: 10px;

    &-tail {
      position: absolute;
      top: 9px;
      left: 7px;
      height: calc(100% + 12px);
      border-left: 2px solid #f3f3f3;
      box-sizing: border-box;
    }

    &-head {
      position: absolute;
      width: 6px;
      height: 6px;
      top: 5px;
      left: 5px;
      background-color: #a3a3a3;
      border-radius: 50%;
      box-sizing: border-box;

      &.active {
        background-color: #e34d59;
      }
    }
  }

  &:nth-last-child(1) {
    margin-bottom: 0;

    .notice-line {
      .notice-line-tail {
        height: calc(100% - 30px);
      }
    }
  }

  .notice-content {
    flex: 1;
    color: #333333;
    font-size: 12px;
    box-sizing: border-box;
    word-break: break-all;
    word-wrap: break-word;

    &-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 14px;
    }

    &-btn {
      text-align: right;
      font-weight: 400;
      font-size: 12px;
      float: right;
      color: #a3a3a3;
      line-height: 14px;
    }

    &-content {
      margin: 10px 0;

      .content-detail-list-box {
        background: #f5f5f5;
        padding: 10px;
        color: #757575;
      }
    }

    &-detail {
      margin-top: 10px;
      background: #f5f5f5;
      padding-top: 10px;
      color: #757575;

      &-wrapper {
        padding: 0px 10px 10px 10px;

        .expand-wrapper {
          .expand-top {
            display: flex;
            margin-top: 10px;

            .expand-time {
              text-align: right;
              flex: 1;
            }
          }

          .expand-content {
            margin-top: 10px;

            .content-detail-list-box {
              padding: 10px;
              background: @color-bg-page;
            }
          }

          &:nth-of-type(1) .expand-top {
            margin-top: 0;
          }
        }
      }

      &-box {
        display: flex;
      }

      &-title {
        flex: 1;
        font-size: 14px;
      }

      &-time {
        flex: 1;
        text-align: right;
        line-height: 20px;
      }
    }
  }
}

.dark {
  .notice-wrapper {
    color: @dark-color-text-primary;
  }

  .notice-content {
    color: @dark-color-text-primary;

    &-btn {
      color: @dark-color-text-primary;
    }

    &-detail {
      background: #202022;
      color: @dark-color-text-primary;

      &-wrapper {
        .expand-wrapper {
          .expand-content {
            .content-detail-list-box {
              background: @dark-color-bg-page;
            }
          }
        }
      }
    }

    .content-detail-list-box {
      background: #202022;
      color: @dark-color-text-primary;
    }
  }

  .notice-line {
    &-tail {
      border-left: 2px solid #383838;
    }
  }
}
</style>
